export function spendingRequest(state = {
    fetching:false,
    fetched: false,
    error:null,
},{
    type,
    payload
}){
    
    switch(type){
        case "CREATE_SPENDING_START":           
        case "UPDATE_SPENDING_START":           
        case "FETCH_ADMIN_SPENDINGS_START":                                 
        case "FETCH_USER_SPENDINGS_START":                                 
        case "FETCH_SPENDING_PAYMENTS_START":                                 
            return {
                ...state, 
                fetching:true,
            }        
        case "CREATE_SPENDING_FULFILLED":           
        case "UPDATE_SPENDING_FULFILLED":           
        case "FETCH_ADMIN_SPENDINGS_FULFILLED":                                 
        case "FETCH_USER_SPENDINGS_FULFILLED":                                 
        case "FETCH_SPENDING_PAYMENTS_FULFILLED":                                 
            return {
                ...state,
                fetching:false, 
                fetched:true, 
                error: null
            }    
        case "CREATE_SPENDING_ERROR":
        case "UPDATE_SPENDING_ERROR":
        case "FETCH_ADMIN_SPENDINGS_ERROR":
        case "FETCH_USER_SPENDINGS_ERROR":
        case "FETCH_SPENDING_PAYMENTS_ERROR":
            return {
                ...state,
                fetching:false, 
                error:payload
            }
        default:
            return state;
    }
    
}